import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_494: DocMigration = {
  maxSchemaVersion: "0.0.494",
  description:
    "Rename levelAnnotationParams to elevationAnnotationParams and rename inner fields (method -> levelAnnotationMethod, offset -> levelAnnotationOffset, minVerticalOffset -> levelAnnotationVerticalSpacing)",
  apply(json: any): any {
    // Migrate elevationViews
    if (json.elevationViews) {
      for (const id in json.elevationViews) {
        const elevationView = json.elevationViews[id];
        if (elevationView.levelAnnotationParams !== undefined) {
          elevationView.elevationAnnotationParams = elevationView.levelAnnotationParams;
          delete elevationView.levelAnnotationParams;

          // Migrate inner fields
          if (elevationView.elevationAnnotationParams) {
            const params = elevationView.elevationAnnotationParams;
            if (params.method !== undefined) {
              params.levelAnnotationMethod = params.method;
              delete params.method;
            }
            if (params.offset !== undefined) {
              params.levelAnnotationOffset = params.offset;
              delete params.offset;
            }
            if (params.minVerticalOffset !== undefined) {
              params.levelAnnotationVerticalSpacing = params.minVerticalOffset;
              delete params.minVerticalOffset;
            }
          }
        }
      }
    }

    // Migrate viewports with ELEVATION_VIEW type
    if (json.viewports) {
      for (const id in json.viewports) {
        const viewport = json.viewports[id];
        if (viewport.viewType === "ELEVATION_VIEW" && viewport.levelAnnotationParams !== undefined) {
          viewport.elevationAnnotationParams = viewport.levelAnnotationParams;
          delete viewport.levelAnnotationParams;

          // Migrate inner fields
          if (viewport.elevationAnnotationParams) {
            const params = viewport.elevationAnnotationParams;
            if (params.method !== undefined) {
              params.levelAnnotationMethod = params.method;
              delete params.method;
            }
            if (params.offset !== undefined) {
              params.levelAnnotationOffset = params.offset;
              delete params.offset;
            }
            if (params.minVerticalOffset !== undefined) {
              params.levelAnnotationVerticalSpacing = params.minVerticalOffset;
              delete params.minVerticalOffset;
            }
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_494;
